import React, { createContext } from "react";
import ProjectFilePlanReducerAction from "./project-file-plan-reducer-action.ts";
import KnownScaleContent from "@/pages/takeoff/context/project-organisation/models/known-scale-content.ts";
import UserDefinedContent from "@/pages/takeoff/context/project-organisation/models/user-defined-content.ts";
import PlanOrigin from "@/pages/takeoff/context/project-organisation/models/plan-origin.ts";
import BaseFileData from "@/pages/takeoff/context/project-organisation/models/base-file-data.ts";
import ProjectOrganisationBuilding from "@/pages/takeoff/context/project-organisation/models/project-organisation-building.ts";
import ProjectOrganisationStorey from "@/pages/takeoff/context/project-organisation/models/project-organisation-storey.ts";

export interface ProjectFilePlanContextProps {
    building: ProjectOrganisationBuilding | undefined,
    storey: ProjectOrganisationStorey | undefined,

    dataContent: KnownScaleContent | UserDefinedContent | undefined,
    
    dataOrigin: PlanOrigin,
    
    urlFilePlan: string;
    storeyFile: BaseFileData | undefined;
    isDirty: boolean;
    isSaving: boolean;

    dispatch: React.Dispatch<ProjectFilePlanReducerAction>;

    setDefinedScale: (definedScale: number | undefined) => void;

    saveCurrentFileData: () => Promise<boolean>;
}

export const ProjectFilePlanContext = createContext<ProjectFilePlanContextProps | undefined>(undefined);